<template>
  <div class="grid" :class="[templateColumns, styling, row.rowType]">
    <div class="py-1 px-2" :class="indent">
        {{row.title}}
        <tooltip v-if="row.tooltip" :text="translate(row.tooltip)"></tooltip>
    </div>
    
    <template v-if="row.rowType !== FinancialRowType.Header">
      <div class="py-1 px-2 text-grey-500 text-xs">{{row.sign}}</div>
      <div class="py-1 px-2 text-grey-500 text-xs text-right italic">{{row.code}}</div>
    </template>
    
    <div v-for="cell in row.cells" class="py-1 px-2 text-right even:bg-grey-100/60">
        <tooltip :disabled="!cell.blurred" :title="translate('confidential')" :text="translate('confidentieel_tooltip')">
            <span v-if="row.color === 'inverted'" v-financial.inverse v-html="cell.text"></span>
            <span v-else-if="row.color === 'none'" v-financial.none v-html="cell.text"></span>
            <span v-else v-financial v-html="cell.text" :class="cell.blurred ? 'blur-sm select-none pointer-events-none' : ''"></span>
        </tooltip>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {FinancialRowType, FinancialStatementsRow} from "../../types";

export default defineComponent({
  name: "row",
  props: {
    row: {
      type: Object as () => FinancialStatementsRow,
      required: true
    }
  },
  data() {
    return {
      FinancialRowType
    }
  },
  computed: {
    indent(): string {
      return this.row.indentation === 0 ? "" : "pl-" + (this.row.indentation * 8);
    },
    templateColumns(): string {
      return this.row.rowType === FinancialRowType.Header 
          ? "grid-cols-[8fr_2fr_2fr_2fr_2fr] mobile:grid-cols-[5fr_2fr_2fr_2fr_2fr]" 
          : "grid-cols-[6fr_1fr_1fr_2fr_2fr_2fr_2fr] mobile:grid-cols-[3fr_1fr_1fr_2fr_2fr_2fr_2fr]";
    },
    styling(): string {
      return this.row.rowType === FinancialRowType.Header 
          ? "border border-primary-300 bg-primary-100 text-base mobile:text-sm text-primary-700 rounded mt-10 first:mt-0 uppercase px-1 py-0.5 tracking-wider text-grey-900 font-bold" 
          : this.row.rowType === FinancialRowType.SubHeader
              ? "border border-grey-300 bg-grey-100/60 mobile:text-xs rounded mt-6 first:mt-0 uppercase px-1 py-0.5 tracking-wider font-bold"
              : "border-b border-dotted border-grey-300 mobile:text-xs";
    }
  }
})
</script>

